<!-- Sin data-micromodal-close en el overlay: un clic afuera no debe borrar el formulario diligenciado. -->
<div [id]="idModal" aria-hidden="true" class="c-modal">
  <div tabindex="-1" class="c-modal_overlay">
    <div role="dialog" aria-modal="true" [attr.aria-labelledby]="idModal + '-title'" class="c-modal_container sa">

      <div class="sa__header">
        <h3 class="sa__title" [id]="idModal + '-title'">Solicita tus Medicamentos de Aplicación Supervisada</h3>
        <button type="button" class="sa__close" (click)="close()" aria-label="Cerrar">
          <img src="./assets/icons/x.svg" alt="">
        </button>
      </div>

      <div class="sa__progress" *ngIf="formSteps.includes(step)">
        Paso {{ stepNumber }} de {{ formSteps.length }}
        <div class="sa__progress-bar">
          <div class="sa__progress-fill" [style.width.%]="stepNumber * 100 / formSteps.length"></div>
        </div>
      </div>

      <form class="sa__body" [formGroup]="form" (ngSubmit)="$event.preventDefault()">

        <!-- Paso 1: datos básicos del paciente (preguntas 1 a 4) -->
        <div *ngIf="step === 'patient'" formGroupName="patient">
          <h4 class="sa__subtitle">Para iniciar, necesitamos algunos datos</h4>
          <div class="sa__notice">
            <img src="./assets/icons/warning.svg" alt="">
            <span>Esta opción es solo para los afiliados de <b>EPS Sanitas</b> en la ciudad de <b>Bogotá</b>.</span>
          </div>
          <p class="sa__text">Relaciona los datos básicos del paciente.</p>

          <label class="sa__field">
            <span class="sa__label">Tipo de documento</span>
            <select class="sa__input" formControlName="identificationType"
              (change)="onIdentificationTypeChange(patientGroup.get('identificationType').value)">
              <option *ngFor="let type of documentTypes" [value]="type.code">{{ type.name }}</option>
            </select>
          </label>

          <label class="sa__field">
            <span class="sa__label">Escribe el número de documento</span>
            <input class="sa__input" [type]="identificationInputType" formControlName="identification"
              [class.error]="showError(patientGroup.get('identification'))">
            <app-form-errors *ngIf="patientGroup.get('identification').touched"
              [errors]="patientGroup.get('identification').errors">Campo obligatorio</app-form-errors>
          </label>

          <div class="sa__check">
            <input type="checkbox" id="saAcceptTerms" formControlName="acceptTerms">
            <label for="saAcceptTerms">
              Al continuar, aceptas los
              <a [routerLink]="['/terminos-y-condiciones']" target="_blank" class="c-blue-medium">términos y condiciones</a>
            </label>
          </div>
          <span class="sa__error" *ngIf="showError(patientGroup.get('acceptTerms'))">Debes aceptar los términos y condiciones</span>

          <div class="sa__check">
            <input type="checkbox" id="saAcceptHabeas" formControlName="acceptHabeasData">
            <label for="saAcceptHabeas">
              ¿Aceptas la
              <a [routerLink]="['/habeas-data']" target="_blank" class="c-blue-medium">política y tratamiento de datos</a>
              para recibir información a través de nuestros canales de Colsubsidio?
            </label>
          </div>
          <span class="sa__error" *ngIf="showError(patientGroup.get('acceptHabeasData'))">Debes aceptar la política y tratamiento de datos</span>
        </div>

        <!-- Paso 2: fórmula médica (preguntas 5 a 8) -->
        <div *ngIf="step === 'formula'" formGroupName="formula">
          <h4 class="sa__subtitle">Paciente, carga las fórmulas médicas</h4>

          <div class="sa__field">
            <span class="sa__label">¿Tienes vigente un código de autorización para la entrega de tus medicamentos?</span>
            <div class="sa__radios">
              <label class="sa__radio">
                <input type="radio" formControlName="hasAuthorizationCode" [value]="true" (change)="onHasAuthorizationCodeChange()"> Sí
              </label>
              <label class="sa__radio">
                <input type="radio" formControlName="hasAuthorizationCode" [value]="false" (change)="onHasAuthorizationCodeChange()"> No
              </label>
            </div>
            <span class="sa__error" *ngIf="showError(formulaGroup.get('hasAuthorizationCode'))">Selecciona una opción</span>
          </div>

          <ng-container *ngIf="formulaGroup.get('hasAuthorizationCode').value !== null">
            <label class="sa__field">
              <span class="sa__label">Escribe el número de fórmula</span>
              <input class="sa__input" type="text" formControlName="formulaNumber"
                [class.error]="showError(formulaGroup.get('formulaNumber'))">
              <app-form-errors *ngIf="formulaGroup.get('formulaNumber').touched"
                [errors]="formulaGroup.get('formulaNumber').errors">Campo obligatorio</app-form-errors>
            </label>

            <label class="sa__field" *ngIf="formulaGroup.get('hasAuthorizationCode').value === true">
              <span class="sa__label">Escribe el código de autorización</span>
              <input class="sa__input" type="text" formControlName="authorizationCode"
                [class.error]="showError(formulaGroup.get('authorizationCode'))">
              <app-form-errors *ngIf="formulaGroup.get('authorizationCode').touched"
                [errors]="formulaGroup.get('authorizationCode').errors">Campo obligatorio</app-form-errors>
            </label>
          </ng-container>

          <div class="sa__field">
            <span class="sa__label">Adjunta tu fórmula médica</span>
            <label class="sa__upload" *ngIf="!file && !compressing" [class.error]="fileTouched && (fileError || !file)">
              <img src="./assets/icons/formula/adjuntar-imagen.svg" alt="">
              <span>Seleccionar archivo</span>
              <input type="file" accept=".jpeg,.jpg,.png,.pdf,image/jpeg,image/png,application/pdf" (change)="onFileSelected($event)">
            </label>
            <div class="sa__file" *ngIf="compressing">
              <span class="sa__file-name">Optimizando imagen…</span>
              <button type="button" class="sa__link" (click)="removeFile()">Cancelar</button>
            </div>
            <div class="sa__file" *ngIf="file">
              <span class="sa__file-name">{{ file.name }} ({{ formatSize(file.size) }})</span>
              <button type="button" class="sa__link" (click)="removeFile()">Quitar</button>
            </div>
            <span class="sa__error" *ngIf="fileError">{{ fileError }}</span>
            <span class="sa__error" *ngIf="fileTouched && !file && !fileError && !compressing">Debes adjuntar la fórmula médica</span>
            <ul class="sa__hints">
              <li>JPEG, JPG, PNG y PDF permitidos (máximo {{ maxSize }}). Si tu foto pesa más, se optimizará automáticamente.</li>
              <li>Recuerda que tus fórmulas deben estar vigentes al momento de la entrega.</li>
              <li>Recuerda adjuntar el número de autorización al momento de realizar la solicitud del pedido cuando el
                medicamento lo requiera. Este requisito aplica especialmente para medicamentos NO PBS y de Alto Costo.
                Contar con esta información es indispensable para gestionar la solicitud de manera oportuna y evitar
                reprocesos o demoras en la entrega.</li>
            </ul>
          </div>
        </div>

        <!-- Paso 3: IPS y confirmación de datos (preguntas 9 y 10) -->
        <div *ngIf="step === 'contact'" formGroupName="contact">
          <label class="sa__field">
            <span class="sa__label">Selecciona la IPS</span>
            <select class="sa__input" formControlName="ipsCode" [class.error]="showError(contactGroup.get('ipsCode'))">
              <option value="" disabled>Selecciona una opción</option>
              <option *ngFor="let ips of ipsList" [value]="ips.code">{{ ips.name }}</option>
            </select>
            <app-form-errors *ngIf="contactGroup.get('ipsCode').touched"
              [errors]="contactGroup.get('ipsCode').errors">Campo obligatorio</app-form-errors>
          </label>

          <h4 class="sa__subtitle">Confirmación de datos</h4>

          <label class="sa__field">
            <span class="sa__label">Nombres del paciente</span>
            <input class="sa__input" type="text" formControlName="names" [class.error]="showError(contactGroup.get('names'))">
            <app-form-errors *ngIf="contactGroup.get('names').touched"
              [errors]="contactGroup.get('names').errors">Campo obligatorio</app-form-errors>
          </label>

          <label class="sa__field">
            <span class="sa__label">Apellidos del paciente</span>
            <input class="sa__input" type="text" formControlName="lastNames" [class.error]="showError(contactGroup.get('lastNames'))">
            <app-form-errors *ngIf="contactGroup.get('lastNames').touched"
              [errors]="contactGroup.get('lastNames').errors">Campo obligatorio</app-form-errors>
          </label>

          <label class="sa__field">
            <span class="sa__label">Número de celular</span>
            <input class="sa__input" type="tel" maxlength="10" formControlName="cellphone" [class.error]="showError(contactGroup.get('cellphone'))">
            <app-form-errors *ngIf="contactGroup.get('cellphone').touched"
              [errors]="contactGroup.get('cellphone').errors">Campo obligatorio</app-form-errors>
          </label>

          <label class="sa__field">
            <span class="sa__label">Correo electrónico</span>
            <input class="sa__input" type="email" formControlName="email" [class.error]="showError(contactGroup.get('email'))">
            <app-form-errors *ngIf="contactGroup.get('email').touched"
              [errors]="contactGroup.get('email').errors">Campo obligatorio</app-form-errors>
          </label>

          <label class="sa__field">
            <span class="sa__label">Número de celular alterno (opcional)</span>
            <input class="sa__input" type="tel" maxlength="10" formControlName="alternateCellphone"
              [class.error]="showError(contactGroup.get('alternateCellphone'))">
            <app-form-errors *ngIf="contactGroup.get('alternateCellphone').touched"
              [errors]="contactGroup.get('alternateCellphone').errors"></app-form-errors>
          </label>
        </div>

        <!-- Paso 4: validar los datos diligenciados (punto 11) -->
        <div *ngIf="step === 'summary'">
          <h4 class="sa__subtitle">Valida los datos diligenciados</h4>
          <p class="sa__text">Revisa que la información sea correcta antes de enviar la solicitud.</p>

          <div class="sa__summary">
            <div class="sa__summary-head">
              <b>Datos del paciente</b>
              <button type="button" class="sa__link" (click)="goTo('patient')">Editar</button>
            </div>
            <dl>
              <dt>Documento</dt>
              <dd>{{ documentTypeName(patientGroup.value.identificationType) }} {{ patientGroup.value.identification }}</dd>
            </dl>
          </div>

          <div class="sa__summary">
            <div class="sa__summary-head">
              <b>Fórmula médica</b>
              <button type="button" class="sa__link" (click)="goTo('formula')">Editar</button>
            </div>
            <dl>
              <dt>¿Tiene código de autorización?</dt>
              <dd>{{ formulaGroup.value.hasAuthorizationCode ? 'Sí' : 'No' }}</dd>
              <dt>Número de fórmula</dt>
              <dd>{{ formulaGroup.value.formulaNumber }}</dd>
              <ng-container *ngIf="formulaGroup.value.hasAuthorizationCode">
                <dt>Código de autorización</dt>
                <dd>{{ formulaGroup.value.authorizationCode }}</dd>
              </ng-container>
              <dt>Archivo</dt>
              <dd>{{ file?.name }}</dd>
            </dl>
          </div>

          <div class="sa__summary">
            <div class="sa__summary-head">
              <b>IPS y datos de contacto</b>
              <button type="button" class="sa__link" (click)="goTo('contact')">Editar</button>
            </div>
            <dl>
              <dt>IPS</dt>
              <dd>{{ ipsName(contactGroup.value.ipsCode) }}</dd>
              <dt>Nombre</dt>
              <dd>{{ contactGroup.value.names }} {{ contactGroup.value.lastNames }}</dd>
              <dt>Celular</dt>
              <dd>{{ contactGroup.value.cellphone }}</dd>
              <dt>Correo electrónico</dt>
              <dd>{{ contactGroup.value.email }}</dd>
              <ng-container *ngIf="contactGroup.value.alternateCellphone">
                <dt>Celular alterno</dt>
                <dd>{{ contactGroup.value.alternateCellphone }}</dd>
              </ng-container>
            </dl>
          </div>
        </div>

        <div *ngIf="step === 'success'" class="sa__result">
          <img src="./assets/icons/successful/exito.svg" alt="">
          <h4 class="sa__subtitle">¡Tu solicitud fue registrada!</h4>
          <p class="sa__text">Número de solicitud: <b>{{ requestId }}</b></p>
          <p class="sa__text">Pronto nos comunicaremos contigo para continuar con el proceso.</p>
        </div>

        <div *ngIf="step === 'error'" class="sa__result">
          <img src="./assets/icons/warning.svg" alt="">
          <h4 class="sa__subtitle">No pudimos registrar tu solicitud</h4>
          <p class="sa__text">{{ errorMessage }}</p>
        </div>
      </form>

      <div class="sa__footer">
        <ng-container *ngIf="formSteps.includes(step)">
          <button type="button" class="sa__btn sa__btn--secondary" *ngIf="step !== 'patient'" (click)="back()" [disabled]="sending">Atrás</button>
          <button type="button" class="sa__btn" *ngIf="step !== 'summary'" (click)="next()" [disabled]="compressing">Continuar</button>
          <button type="button" class="sa__btn" *ngIf="step === 'summary'" (click)="submit()" [disabled]="sending">
            {{ sending ? 'Enviando...' : 'Enviar solicitud' }}
          </button>
        </ng-container>
        <ng-container *ngIf="step === 'error'">
          <button type="button" class="sa__btn sa__btn--secondary" (click)="close()">Cerrar</button>
          <button type="button" class="sa__btn" (click)="goTo('summary')">Intentar de nuevo</button>
        </ng-container>
        <button type="button" class="sa__btn" *ngIf="step === 'success'" (click)="close()">Finalizar</button>
      </div>
    </div>
  </div>
</div>
